import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { onTimeChange } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductServiceService } from 'src/app/services/core/quickbook/product-services/product-service.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { CamelCasePipe } from 'src/app/pipes/camelcase.filter/camelcase.filter.pipe';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { sweetAlert } from 'src/app/utils/swal';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
@UntilDestroy()

@Component({
  selector: 'app-add-product-service',
  templateUrl: './add-product-service.component.html',
  styleUrls: ['./add-product-service.component.css']
})
export class AddProductServiceComponent implements OnInit {
  submitted = false;
  productServiceForm!: FormGroup;
  user: any;
  accountDetail: any;
  levelOfServices: any;
  fundingSources: any;
  spacetypes: any;
  addons:any;

  selectedAddon:any = "";
  selectedSpacetype:any = "";
  selectedLos:any="";

  productId: any;
  constructor(
    private fundingSourceService : FundingSourceService,
    private addonService : AddonService,
    private SpaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private credentialService: CredentialService,
    private sharedDataService: SharedDataService,
    private productService: ProductServiceService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.productId = params["id"];
        if (this.productId) {
          this.getProductbyId();
        }
      }
      );

    this.productServiceForm = this.fb.group({
      Name: ['', Validators.required],
      Type: ['', Validators.required],
      Sku: ['0'],
      Description: [''],
      QtyOnHand: [0, Validators.required],
      UnitPrice: [0, Validators.required],
      IncomeAccountRef: this.fb.group({
        value: ['', Validators.required],
        name: ['']
      }),
      reference:this.fb.group({
         id:[''],
        name:[''],
        type:[''],
        priority:['0'],
        isPerMile:[false],
        fundingSource:['']
      })
    });
    // this.productServiceForm.get('reference')?.setValidators(this.atLeastOneRequiredValidator());


    // this.getCredentialCompanies();
    this.getUser();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getAllAddons();
    this.getAccountDetail();
    this.getFundingSources();

  }

  get form() {
    return this.productServiceForm.controls;
  }

  get incomeAccountRef() {
    return (this.productServiceForm.get('IncomeAccountRef') as FormGroup).controls;
  }

  get reference() {
    return this.productServiceForm.get('reference') as FormGroup;
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.productServiceForm.patchValue({
          InvStartDate: moment().tz(this.user.timeZone).toISOString(),
        })
      }
    })
  }



  getProductbyId() {
    this.productService.getProductServiceById(this.productId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        console.log("product service data", data);
         this.productServiceForm.patchValue({
            ...data,
          })
        if ( data.IncomeAccountRef) {
          this.productServiceForm.patchValue({
            ...data,
            IncomeAccountRef: {
              value: data.IncomeAccountRef.value,
              name: data.IncomeAccountRef.name
            }
          })
        }

        if (data.reference) {
          if (data.reference.type === "los") {
            this.selectedLos = data.reference.id
          } else if (data.reference.type === "addon") {
            this.selectedAddon = data.reference.id
          } else if (data.reference.type === "spacetype") {
            this.selectedSpacetype = data.reference.id
          }
        }

      //  this.atLeastOneRequiredValidator();
       this.productServiceForm.get('reference')?.updateValueAndValidity();

      }
    })
  }

  onSave() {
    this.submitted = true
    if (this.productServiceForm.invalid) return;
    let payload = this.productServiceForm.value;
    payload = {
      ...this.productServiceForm.value,
      // company: this.selectedCompany
    }
    this.productService.saveProductService(this.productId, payload).subscribe((data: any) => {
      if (data) {
        this.router.navigateByUrl('/quickbook/services')
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }
  )
  }

  getAccountDetail() {
    this.productService.getAccount().subscribe((data: any) => {
      if (data) {
        this.accountDetail = data
      }
    })
  }

  getLevelOfService() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.levelOfServices = data.results.map((item: any) => {
            return {
              ...item,
              title: new CamelCasePipe().transform(item.title)
            };
          });
        }
      })
  }

  getSpaceTypes() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.SpaceTypeService.get(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.spacetypes = data.results;
      }
    })
  }

  getFundingSources() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
        }
      });
  }

  getAllAddons() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.addonService.getAddons(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.addons = data.results;
      }
    })
  }

  // Common helper method
private updateCustomField(definition: any, type:any) {

  if (definition && type) {
    this.productServiceForm.get('reference')?.patchValue({
        name: definition.title,
        id:definition.id,
        type: type
    })
  } 
}

onLosChange() {
  // const selectedId = (event.target as HTMLSelectElement).value;

  if (!this.selectedLos) {
    // User unselected LOS → reset everything
    this.selectedLos = null;
    this.selectedSpacetype = null;
    this.selectedAddon = null;
    this.productServiceForm.get('reference')?.reset({
      name: '',
      id: '',
      type:''
    });
    return;
  }

  // this.selectedLos = selectedId;
  this.selectedSpacetype = null;
  this.selectedAddon = null;

  const los = this.levelOfServices.find((l: any) => l.id === this.selectedLos);
  this.updateCustomField(los, 'los');
  this.productServiceForm.get('reference')?.updateValueAndValidity();

}

onSpaceTypeChange() {

  if (!this.selectedSpacetype) {
    this.selectedSpacetype = null;
    this.selectedLos = null;
    this.selectedAddon = null;
     this.productServiceForm.get('reference')?.reset({
      name: '',
      id: ''
    });
    return;
  }

  // this.selectedSpacetype = selectedId;
  this.selectedLos = null;
  this.selectedAddon = null;

  const spaceType = this.spacetypes.find((s: any) => s.id === this.selectedSpacetype);
  this.updateCustomField(spaceType, 'spacetype');
  this.productServiceForm.get('reference')?.updateValueAndValidity();

}

onAddonChange() {

  if (!this.selectedAddon) {
    this.selectedAddon = null;
    this.selectedLos = null;
    this.selectedSpacetype = null;
     this.productServiceForm.get('reference')?.reset({
      name: '',
      id: ''
    });
    return;
  }

  // this.selectedAddon = selectedId;
  this.selectedLos = null;
  this.selectedSpacetype = null;

  const addon = this.addons.find((a: any) => a.id === this.selectedAddon);
  this.updateCustomField(addon, 'addon');
  this.productServiceForm.get('reference')?.updateValueAndValidity();
}

  togglePerMile(event: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.productServiceForm.patchValue({
      reference:{
        isPerMile: isChecked
      }
    });
  }
  onIncomeAccountRefChange(event: any) {
    const incomeAccountRef = this.accountDetail.find((acc: any) => acc.id === event.value);
    if (incomeAccountRef) {
      this.productServiceForm.patchValue({
        IncomeAccountRef: {
          name: incomeAccountRef.Name
        }
      });
    } else {
      this.productServiceForm.patchValue({
        IncomeAccountRef: {
          name: ''
        }
      });
    }

  }


  atLeastOneRequiredValidator(): ValidatorFn {
    return (): ValidationErrors | null => {
      if (this.selectedLos || this.selectedSpacetype || this.selectedAddon) {
        return null; // at least one is selected
      }
      return { atLeastOneRequired: true }; // none selected
    };
  }

}
